export const formatCurrencyBRL = (value) => {
  const numericValue = Number(value) || 0;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/CurrencyDisplay/utils/currencyDisplayHelpers.js